import _ from 'lodash';
import LocomotiveScroll from 'locomotive-scroll';
const locomotiveScroll = new LocomotiveScroll();

const { gsap } = require('gsap');
const { ScrollTrigger } = require("gsap/ScrollTrigger");

const ScrollEvents = function () {

	const isMobile = () => {
		return window.screen.width < 768
	}

	const parallaxWebdoor = function () {

		gsap.utils.toArray(".js-text-webdoor").forEach(el => {
			gsap.to(el, {
				scrollTrigger: {
					trigger: $(el).closest('.webdoor'),
					start: "top 40%",
					end: "bottom center",
					// markers:true,
					toggleClass: {
						targets: el, className: 'motion-in'
					},
				}
			});
		})

		gsap.fromTo($('.webdoor').find('img, video'),
			{
				yPercent: 0,
				scale: 1,
			}, {
			yPercent: 80,
			scale: 1.4,
			ease: "none",
			scrollTrigger: {
				trigger: '.webdoor',
				start: "top top",
				end: "bottom -=50%",
				scrub: true,
				invalidateOnRefresh: true,
			}
		});

		gsap.to($('.wave-footer'), {
			yPercent: 200,
			ease: "none",
			scrollTrigger: {
				trigger: $('.section-start'),
				start: "30% top",
				end: "bottom top",
				scrub: true,
				// markers:true
			}
		});
		/* gsap.to($('.wave-footer'), {
			backgroundPosition: '100% bottom',
			ease: "none",
			scrollTrigger: {
				trigger: $('.section-start'),
				start: "top top",
				end: "bottom top",
				scrub: true,
				// markers:true
			}
		}); */

	}

	const slideTopProducts = () => {
		//#wrap-home-products

		const wrapperP = "#wrap-home-products";

		/* if(!isMobile()) {
			let heightPage = $(wrapperP).outerHeight(true) * 1.2;
			$(wrapperP).closest('section').height(heightPage);
		} */


		let panels = document.querySelectorAll(".card-product");
		let panel1 = document.querySelector(".card-product-1");
		let panel0 = document.querySelector(".card-product-0");
		let panel2 = document.querySelector(".card-product-2");

		let panel4 = document.querySelector(".card-product-4");
		let panel3 = document.querySelector(".card-product-3");
		let panel5 = document.querySelector(".card-product-5");

		if(!isMobile()) {

			gsap.set(panel1, { yPercent: 0 })
			gsap.set(panel0, { yPercent: 30 })
			gsap.set(panel2, { yPercent: 50 })

			gsap.set(panel4, { yPercent: 20 })
			gsap.set(panel3, { yPercent: 0 })
			gsap.set(panel5, { yPercent: 0 })
			
			let tl1 = gsap.timeline({
				ease: "none",
				scrollTrigger: {
					trigger: wrapperP,
					start: "top top",
					// end: "+=450%",//bottom +="+panels[0].clientHeight * panels.length,//"+=600%",
					scrub: 2,
					// pin: true,
					// markers : true
				}
			});
	
			tl1.to(panel1, {
				yPercent: 20,
				ease: "none",
				autoAlpha: .6,
				stagger: 0.8,
			}, 0);
	
			tl1.to(panel0, {
				yPercent: -80,
				ease: "none",
				opacity: 1,
				stagger: 1,
			}, 0);
	
			tl1.to(panel2, {
				yPercent: -110,
				ease: "none",
				autoAlpha: 1,
				stagger: 0.6,
			}, 0);
	
			tl1.to(panel4, {
				yPercent: -20,
				ease: "none",
				autoAlpha: .6,
				stagger: 0.6,
			}, 0);
	
			tl1.to(panel3, {
				yPercent: -20,
				ease: "none",
				opacity: 1,
				stagger: 1,
			}, 0);
	
			tl1.to(panel5, {
				yPercent: -10,
				ease: "none",
				autoAlpha: 1,
				stagger: 0.6,
			}, 0);

		} else {

			gsap.set(panels, { yPercent: 10, autoAlpha : 0 })

			gsap.utils.toArray(panels).forEach(el => {
				gsap.to(el, {
					yPercent : 0,
					autoAlpha:1,
					ease: "power4.out",
					duration: 1,
					scrollTrigger: {
						trigger: $(el),
						start: "top 75%",
						end: "center top",
						scrub: 2,
						// markers:true
					}
				});
			})

		}


	}

	const zoomOutVideo = () => {

		gsap.fromTo($("#wrap-video").find('img'), {
			scale: 2,
		}, {
			scale: 1,
			maxWidth: '1920px',
			height: isMobile() ? '50vh' : '95svh',
			ease: "power4.out",
			duration: 1,
			scrollTrigger: {
				trigger: $("#wrap-video"),
				start: "top 75%",
				end: "80% bottom",
				scrub: 2,
				invalidateOnRefresh: true,
				// markers:true
			}
		});
	}

	const animeTextIntro = (el) => {

		gsap.utils.toArray(".text-anim").forEach(el => {
			gsap.to(el, {
				//height: 0,
				ease: "power4.out",
				duration: 1,
				scrollTrigger: {
					trigger: $(el).closest('section'),
					start: "top 70%",
					end: "center top",
					scrub: 2,
					toggleClass: 'motion-in',
					// markers:true
				}
			});
		})

	}

	const elmToScroll = function (el) {
		let _this = el.attr('data-scrollto');
		let _offset = el.attr('data-offset');
		
		setTimeout(() => {
			scrollToElm(_this, _offset);
		}, 500);
	}

	const scrollToElm = function (target, _top) {

		if (!_top) {
			_top = document.querySelector('header').clientHeight;
		}

		history.replaceState(null, null, ' ');

		gsap.to(window,
			{
				duration: .5,
				scrollTo: (document.querySelector(target).offsetTop - _top),
				ease: "none",
			}
		);


	}

	const last3Home = () => {
	
		const wrapperP = "#wrap-last-3-products";
		// let heightPage = $(wrapperP).outerHeight(true) * 2;

		// $(wrapperP).height(heightPage);

		let panels = document.querySelectorAll(".card-1-3-product");
		let panel1 = document.querySelector(".card-1-3-product-1");
		let panel0 = document.querySelector(".card-1-3-product-0");
		let panel2 = document.querySelector(".card-1-3-product-2");

		if( !isMobile() ) {

			gsap.set(panel1, { yPercent: -10, opacity:0 })
			gsap.set(panel0, { yPercent: 30, autoAlpha:0 })
			gsap.set(panel2, { yPercent: 30, autoAlpha:0 })


			let tl1 = gsap.timeline({
				ease: "none",
				scrollTrigger: {
					trigger: wrapperP,
					start: "top 85%",
					end: 'bottom top',
					scrub: true,
					// pin: true,
					// duration:1,
					pinSpacing:false,
					// markers : true
				}
			});

			tl1.to(panel1, {
				yPercent: 0,
				autoAlpha:1,
				duration:2,
				ease: "none",
			});
		

			tl1.to(panel0, {
				yPercent: 0,
				autoAlpha:1,
				duration:3,
				ease: "none",
			},'1');


			tl1.to(panel2, {
				yPercent: 0,
				autoAlpha:1,
				duration:3,
				ease: "none",
			},'1');

			tl1.to({}, {duration: 10})
		} else {

			gsap.set(panels, { yPercent: 10, autoAlpha : 0 })

			gsap.utils.toArray(panels).forEach(el => {
				gsap.to(el, {
					yPercent : 0,
					autoAlpha:1,
					ease: "power4.out",
					duration: 1,
					scrollTrigger: {
						trigger: $(el),
						start: "top 75%",
						end: "center top",
						scrub: 2,
						// markers:true
					}
				});
			})

		}
	
	}

	const expImage = (() => {
		gsap.utils.toArray(".revealUp").forEach(el => {
			gsap.fromTo(el,
				{
					scale: 1.4,
					yPercent: 55
				}, {
				yPercent: 0,
				scale: 1,
				autoAlpha: 1,
				ease: "none",
				scrollTrigger: {
					trigger: el,
					start: "top bottom",
					end: "center bottom",
					scrub: 2
				}
			});
		})

	})

	const layerMaskAnimation = (() => {
		gsap.utils.toArray(".mask-layer-animation").forEach(el => {
			gsap.to(el, {
				//height: 0,
				ease: "power4.out",
				duration: 1,
				scrollTrigger: {
					trigger: el,
					start: "top center",
					end: "center top",
					scrub: 2,
					toggleClass: 'motion-in'
				}
			});
		})

	})

	const listProducts = () => {

		ScrollTrigger.batch(".card-product-show", {
			onEnter: elements => {
			  gsap.from(elements, {
				autoAlpha: 0,
				y: 60,
				stagger: 0.20
			  });
			},
			once: false
		  });
	}; 

	// detail tijela
	const spriteProduct = () => {

		setTimeout(() => {
			window.scrollTo({top: 0});
			// console.clear();
		}, 500);

		const canvas = document.getElementById("animation-boske");
		const context = canvas.getContext("2d");

		// let imageW = 1920;//960;
		// let imageH = 1080;//540;

		const screenH = window.innerHeight;//screen.availHeight;
		const screenW = window.innerWidth;//screen.availWidth;

		let imageW = 0;//screenW;//960;
		let imageH = 0;//540;

		if(screen.width > screen.height){
			imageW = 1920;//screenW;//960;
			imageH = screenH;//540;
		}else{
			imageW = 1080;//screenW;//960;
			imageH = screenH;//540;
		}


		console.log(screenW, screenH);
		console.log( (canvas.width/2) - (imageW/2), (canvas.height/2) - (imageH/2) );

		if(screen.width > screen.height){
			canvas.width = screenW;//1920;//;
			canvas.height = screenH;//1080;//;
		} else {
			canvas.width = 1080;//1920;//;
			canvas.height = 1920;//1080;//;

		}


		const frameCount = 260;//180;
		const imagesCount = 180;
		const pathName = $('#wrap-options-color').data('path');
		const typeExt = $('#wrap-options-color').data('ext');
		console.log(typeExt);
		const currentFrame = (index) =>`${pathName}${(index + 1).toString().padStart(4, "0")}${typeExt}`;

		const images = [];
		const elmSprite = {
			frame 		: 0,
			scroll_y 	: 0
		};

		for (let i = 0; i < imagesCount; i++) {
			const img = new Image();
			img.src = currentFrame(i);
			images.push(img);
		}

		gsap.to(elmSprite, {
			frame: frameCount - 1,
			snap: "frame",
			ease: "none",
			scrollTrigger: {
				trigger: ".canvas-container",
				start: "top top",
				end: "+=4500",
				// markers: true,
				pin: true,
				scrub: true
			},
			onUpdate: render // use animation onUpdate instead of scrollTrigger's onUpdate
		});

		images[0].onload = render;

		function render() {

			const pauses = [
				{
					start: 59, end: 80
				},
				{
					start: 79, end: 130
				},
				{
					start: 129, end: 170
				},
				{
					start: 169, end: 240
				},
			];

			elmSprite.frame = parseInt(elmSprite.frame);
			elmSprite.scroll_y = elmSprite.frame;

			// oculta menu inferior
			if (elmSprite.scroll_y < 20){
				$('#footer-buy').addClass('motion-in');
			}else{
				$('#footer-buy').removeClass('motion-in');
			}

			// console.log(elmSprite.frame);
			// console.log( `%c scroll-main ${elmSprite.scroll_y}`, `color:red;`);

			let classTexts = '.caption-splash-text';

			if (elmSprite.scroll_y < 20){

				$(canvas).addClass('start-scroll');
				$('#article-start').addClass('motion-in');

				setTimeout(() => {
					$(canvas).addClass('motion-in');
				}, 500);
			}
			else if (elmSprite.scroll_y > 20 && elmSprite.scroll_y < 60) {

				$(canvas).removeClass('start-scroll');
				$('#article-start').removeClass('motion-in');
				
				$(classTexts).removeClass('motion-in');
			
			//-> ## PAUSE 1
			}else if (elmSprite.scroll_y > pauses[0].start && elmSprite.scroll_y < pauses[0].end)  {//&& elmSprite.scroll_y < pauses[0].end)

				/* console.log('pause 1');

				console.log('frame ',elmSprite.frame);
				console.log('scroll ',elmSprite.scroll_y); */

				$(classTexts).removeClass('motion-in');
				$(`#text-1`).addClass('motion-in');

				if (elmSprite.scroll_y > (pauses[0].end )) {
					$(classTexts).removeClass('motion-in');
				}

				elmSprite.frame = pauses[0].start;
				
			//-> ## PAUSE 2	
			}else if (elmSprite.scroll_y > pauses[1].start && elmSprite.scroll_y < pauses[1].end) {

				// console.log('pause 2');

				// continua de onde ultimo sprite pausou subtraindo com frameAtual pelo scroll continuo
				elmSprite.frame = elmSprite.frame - (pauses[0].end - pauses[0].start);

				$(classTexts).removeClass('motion-in');	

				/* console.log('frame ',elmSprite.frame);
				console.log('scroll ',elmSprite.scroll_y); */

				if(elmSprite.scroll_y >= 112){
					$(`#text-2`).addClass('motion-in');
					elmSprite.frame = 93;
				}

				// console.log(elmSprite.frame);

			
			//-> ## PAUSE 3	
			}else if (elmSprite.scroll_y > pauses[2].start && elmSprite.scroll_y < pauses[2].end) {

				// console.log('pause 3');

				// continua de onde ultimo sprite pausou subtraindo com frameAtual pelo scroll continuo
				elmSprite.frame = elmSprite.frame - ((pauses[1].end - 14) - pauses[1].start);

				$(classTexts).removeClass('motion-in');	

				/* console.log('frame ',elmSprite.frame);
				console.log('scroll ',elmSprite.scroll_y); */

				if(elmSprite.scroll_y >= 144){//147
					$(`#text-4`).addClass('motion-in');
					canvas.classList.add('zoom-in');
					elmSprite.frame = 109;//109
				}else{
					canvas.classList.remove('zoom-in');
				}
			
			//-> ## PAUSE 4	
			}else if (elmSprite.scroll_y > pauses[3].start && elmSprite.scroll_y < pauses[3].end) {

				canvas.classList.remove('zoom-in');

				// console.log('pause 4');

				// continua de onde ultimo sprite pausou subtraindo com frameAtual pelo scroll continuo
				elmSprite.frame = elmSprite.frame - ((pauses[2].end + 20) - pauses[2].start);

				$(classTexts).removeClass('motion-in');	

				/* console.log('frame ',elmSprite.frame);
				console.log('scroll ',elmSprite.scroll_y); */

				if(elmSprite.scroll_y >= 220)
					$(`#text-5`).addClass('motion-in');

				if(elmSprite.scroll_y >= 240)
					elmSprite.frame = 178;
				

			} else {
				// $(classTexts).removeClass('motion-in');
				if(elmSprite.scroll_y >= 255)
					$(classTexts).removeClass('motion-in');	

				return;
			}

			// const posX = (canvas.width/2) - (imageW/2);
			// const posY = (canvas.height/2) - (imageH/2);

			/* 
			// if 960 as larguras
			const posX = (canvas.width/2) - (imageW);
			const posY = (canvas.height/2) - (imageH); 
			*/

			let posX = ( canvas.width - imageW ) / 2;
			let posY = (canvas.height - imageH) / 2;

			if(screen.width < screen.height){
				posX = ( canvas.width - imageW ) / 2;
				posY = (canvas.height - imageH) / 10;
			}
			
/* 			if(screen.width < 580) {
				imageW = 250;//960;
				imageH = 200;//540;

				posX = - 680;//(canvas.width/2) - (imageW/2);
				posY = 20;//(canvas.height/2) - (imageH/2);
			}
 */			

			context.clearRect(0, 0, canvas.width, canvas.height);
			context.drawImage(images[elmSprite.frame], posX, posY);
		}

	}

	// detail pinha
	const spriteProductPinha = () => {
		
		console.log('init spriteProductPinha');

		const canvas = document.getElementById("animation-boske-pinha");
		const context = canvas.getContext("2d");

		setTimeout(() => {
			window.scrollTo({top: 0});
			
			//-> entrada da pinha
			setTimeout(() => {
				$(canvas).addClass('introPinha');
			}, 1000);
		}, 500);

		// VIEWPORT REAL
		let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
		let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

		// let imageW = vh + ((vw * 2) / 100);//960;
		// let imageH = (vh - ((vh * 2) / 100));//540;

		let screenH = 0;
		let screenW = 0;

		screenH = (screen.availHeight);
		screenW = screen.availWidth;
		

/* 		console.log(`JANELA = height: ${vw} | width: ${vh}`);
		console.log(screenW, screenH);
 */

		if(vw > vh){
			console.log('canvas Width MAIOR que Height');
			canvas.width = 1920;//;
			canvas.height = 1080;//;
		} else {
			console.log('canvas Width MENOR que Height');
			canvas.width = 980;//screenH;
			canvas.height = 1820;//screenW * 1.2;

		}


		const frameCount = 210;//180;
		const imagesCount = 140;
		let pathName = $('#wrap-options-color').data('path');
		const currentFrame = (index) =>
			`${pathName}${(
				index + 1
			)
				.toString()
				.padStart(4, "0")}.png?v=2`;

		//diretorio diferente  se telas menores
		/* if(vw < 1920){
			console.log(pathName);
			console.log(pathName.split('pinha')[0]);
			pathName = pathName.split('pinha')[0]+"pinha_big/anime pinha vrs3";
			console.log(pathName);
		}  */

		const images = [];
		const elmSprite = {
			frame 		: 0,
			scroll_y 	: 0
		};

		console.log(pathName);

		for (let i = 8; i < imagesCount; i++) {
			const img = new Image();
			img.src = currentFrame(i);
			images.push(img);
		}

		gsap.to(elmSprite, {
			frame: frameCount - 1,
			snap: "frame",
			ease: "none",
			scrollTrigger: {
				trigger: ".canvas-container",
				start: "top top",
				end: vw > vh ? "+=6000" : "+=4500",
				// markers: true,
				pin: true,
				scrub: true
			},
			onUpdate: render // use animation onUpdate instead of scrollTrigger's onUpdate
		});

	
		images[0].onload = render;

		function render() {

			const pauses = [
				{
					start: 20, end: 39
				},
				{
					start: 38, end: 100
				},
				{
					start: 99, end: 200
				},

			]

			elmSprite.frame = parseInt(elmSprite.frame);
			elmSprite.scroll_y = elmSprite.frame;

			//********************************************** */
			//********************************************** */
			// div para debug em Pinha
			if(document.getElementById('div-debug')){
				$("#viwport").html(`w: ${vw} X h: ${vh}`);
				$("#scrollY").html(`Scroll: ${elmSprite.scroll_y}`);
			}
			//********************************************** */
			//********************************************** */

			// oculta menu inferior
			if (elmSprite.scroll_y < 7){
				$('#footer-buy').addClass('motion-in');
				$('#article-start').addClass('motion-in');
			}else{
				$('#article-start').removeClass('motion-in');
				$('#footer-buy').removeClass('motion-in');
			}

			/* console.log(elmSprite.frame);
			console.log('-------------------------------------------------------');
			console.log( `%c scroll-Y ${elmSprite.scroll_y}`, `color:red;`); */

			let classTexts = '.caption-splash-text';

			if (elmSprite.scroll_y < 20){				
				$(classTexts).removeClass('motion-in'); 
				setTimeout(() => {
					$(canvas).addClass('motion-in');
				}, 500);
			}
			
			// PAUSE 1
			else if (elmSprite.scroll_y > pauses[0].start && elmSprite.scroll_y < pauses[0].end) {
				
				console.log('pause 1');

				console.log('frame ',elmSprite.frame);

				$(classTexts).removeClass('motion-in');
				$(`#text-1`).addClass('motion-in');

				if (elmSprite.scroll_y > (pauses[0].end )) {
					$(classTexts).removeClass('motion-in');
				}

				elmSprite.frame = pauses[0].start;

			// PAUSE 2
			}else if (elmSprite.scroll_y > pauses[1].start && elmSprite.scroll_y < pauses[1].end) {
				
				console.log('pause 2');

				// continua de onde ultimo sprite pausou subtraindo com frameAtual pelo scroll continuo
				elmSprite.frame = elmSprite.frame - (pauses[0].end - pauses[0].start);

				$(classTexts).removeClass('motion-in');	

				console.log('frame ',elmSprite.frame);

				if(elmSprite.scroll_y >= 70){
					$(`#text-2`).addClass('motion-in');
					elmSprite.frame = 51;
				}

				console.log(elmSprite.frame);
				
			// PAUSE 3
			}else if (elmSprite.scroll_y > pauses[2].start && elmSprite.scroll_y < pauses[2].end) {
				
				console.log('pause 3');

				// continua de onde ultimo sprite pausou subtraindo com frameAtual pelo scroll continuo
				elmSprite.frame = elmSprite.frame - ((pauses[1].end - 14) - pauses[1].start);

				$(classTexts).removeClass('motion-in');	

				console.log('frame ',elmSprite.frame);

				if(elmSprite.scroll_y >= 171){
					$(`#text-3`).addClass('motion-in');
					elmSprite.frame = 125;
				}

				console.log(elmSprite.frame);

			} else {
				// $(classTexts).removeClass('motion-in');
				console.log('end');
				if(elmSprite.scroll_y >= 179)
					$(classTexts).removeClass('motion-in');	

				return;
			}

			
			// let posX = (canvas.width/2) - (imageW/2);
			// let posY = (canvas.height/2) - (imageH/2); 
			

			var ratio = images[elmSprite.frame].naturalWidth / images[elmSprite.frame].naturalHeight;
			var Nwidth = canvas.width;
			var Nheight = (Nwidth / ratio);
						
			context.clearRect(0, 0, canvas.width, canvas.height);
			context.imageSmoothingEnabled = false;
			// context.drawImage(images[elmSprite.frame], posX, posY);
			// context.drawImage(images[elmSprite.frame], 0, 0);
			
			/* context.drawImage(
				images[elmSprite.frame], 0, 0, imageW, imageH,
				0, 0, screenW, screenH
			); */

			context.drawImage(images[elmSprite.frame], 0, 0, Nwidth, Nheight);
		}

	}

	// detail guia
	const spriteProductGuia = () => {
		
		console.log('init spriteProductGuia');

		const canvas = document.getElementById("animation-boske-guia");
		const context = canvas.getContext("2d");

		setTimeout(() => {
			window.scrollTo({top: 0});
			
			//-> entrada da guia
			// setTimeout(() => {
			// 	$(canvas).addClass('introGuia');
			// }, 1000);
		}, 500);

		// VIEWPORT REAL
		let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
		let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

		// let imageW = vh + ((vw * 2) / 100);//960;
		// let imageH = (vh - ((vh * 2) / 100));//540;

		let imageW = 0;//screenW;//960;
		let imageH = 0;//540;

		let screenH = window.innerHeight;//(screen.availHeight);
		let screenW = window.innerWidth;//screen.availWidth;

		if(screen.width > screen.height){
			imageW = 1920;//screenW;//960;
			imageH = screenH;//540;
		}else{
			imageW = 1080;//screenW;//960;
			imageH = screenH;//540;
		}

		

/* 		console.log(`JANELA = height: ${vw} | width: ${vh}`);
		console.log(screenW, screenH);
 */

		// if(vw > vh){
			if(screen.width > screen.height){
				canvas.width = 1920;//1600;//1920;//;
				canvas.height = 1080;//900;//1080;//;
			}else{
				canvas.width = 1080;//1600;//1920;//;
				canvas.height = 1920;//900;//1080;//;
			}
		// } else {
		// 	console.log('canvas Width MENOR que Height');
		// 	canvas.width = 1200;//900;//screenH;
		// 	canvas.height = 900;//1600;//screenW * 1.2;

		// }

		console.log('canvas width = ', canvas.width);

		const frameCount = 280;//210;//180;
		const imagesCount = screen.width > screen.height ? 248 : 234;
		let pathName = $('#wrap-options-color').data('path');
		const currentFrame = (index) =>
			`${pathName}${(
				index + 1
			)
				.toString()
				.padStart(4, "0")}.png?v=2`;


		const images = [];
		const elmSprite = {
			frame 		: 0,
			scroll_y 	: 0
		};

		for (let i = 8; i < imagesCount; i++) {
			const img = new Image();
			img.src = currentFrame(i);
			images.push(img);
		}

		gsap.to(elmSprite, {
			frame: frameCount - 1,
			snap: "frame",
			ease: "none",
			scrollTrigger: {
				trigger: ".canvas-container",
				start: "top top",
				end: vw > vh ? "+=5000" : "+=4500",
				markers: false,
				pin: true,
				scrub: true
			},
			onUpdate: render // use animation onUpdate instead of scrollTrigger's onUpdate
		});

	
		images[0].onload = render;

		function render() {

			/* const pauses = [
				{
					start: 21, end: 45
				},
				{
					start: 44, end: 125
				},
				{
					start: 124, end: 170
				},
				{
					start: 169, end: 275
				},

			] */
			const pauses = [
				{
					start: 21
				},
				{
					start: 44
				},
				{
					start: 115
				},
				{
					start: 183
				},

			]

			elmSprite.frame = parseInt(elmSprite.frame);
			elmSprite.scroll_y = elmSprite.frame;

			//********************************************** */
			//********************************************** */
			// div para debug em Pinha
			if(document.getElementById('div-debug')){
				$("#viwport").html(`w: ${vw} X h: ${vh}`);
				$("#scrollY").html(`Scroll: ${elmSprite.scroll_y}`);
			}
			//********************************************** */
			//********************************************** */

			// oculta menu inferior
			if (elmSprite.scroll_y <= 15){
				$('#footer-buy').addClass('motion-in');
				$('#article-start').addClass('motion-in');
			}else{
				$('#article-start').removeClass('motion-in');
				$('#footer-buy').removeClass('motion-in');
			}

			/* console.log('======================================================');
			console.log(elmSprite.frame);
			console.log( `%c scroll-Y ${elmSprite.scroll_y}`, `color:red;`);
			console.log('======================================================'); */

			let classTexts = '.caption-splash-text';

			if (elmSprite.scroll_y < 20){	
				$(canvas).removeClass('canvas-start');	
				$(canvas).addClass('canvas-zoomout');	
				$(classTexts).removeClass('motion-in'); 
				setTimeout(() => {
					$(canvas).addClass('motion-in');
				}, 500);
			}

			if(elmSprite.scroll_y > pauses[0].start){
				$(canvas).addClass('canvas-zoomout');
				$(classTexts).removeClass('motion-in');

				if (elmSprite.scroll_y > 30) {
					$(`#text-1`).addClass('motion-in');
				}
				elmSprite.frame = 24;

			}

			if(elmSprite.scroll_y > pauses[1].start){
				$(canvas).removeClass('canvas-zoomout');
				$(canvas).removeClass('canvas-top');
				$(classTexts).removeClass('motion-in');
				$(canvas).removeClass('canvas-start');

				elmSprite.frame = elmSprite.scroll_y - 10;

				if (elmSprite.scroll_y > 58) {
					$(`#text-2`).addClass('motion-in');
					// elmSprite.frame = 75;
				}
				if (elmSprite.scroll_y > 94) {
					$(classTexts).removeClass('motion-in');
				}
			}
			
			if(elmSprite.scroll_y > pauses[2].start){
				$(classTexts).removeClass('motion-in');
				$(canvas).addClass('canvas-top');

				elmSprite.frame = elmSprite.scroll_y - 10;

				if (elmSprite.scroll_y > pauses[2].start) {
					$(`#text-3`).addClass('motion-in');
					// elmSprite.frame = 75;
				}
				if (elmSprite.scroll_y > 165) {
					$(classTexts).removeClass('motion-in');
				}				
			}
			
			if(elmSprite.scroll_y > pauses[3].start){
				$(classTexts).removeClass('motion-in');

				elmSprite.frame = elmSprite.scroll_y - 10;

				if (elmSprite.scroll_y > pauses[3].start) {
					$(`#text-4`).addClass('motion-in');
					// elmSprite.frame = 75;
				}

			}

			if(elmSprite.scroll_y > imagesCount){
				$(classTexts).removeClass('motion-in');
				elmSprite.frame = imagesCount;
				return
			}
						

			if(screen.width < screen.height){
				var ratio = images[elmSprite.frame].naturalWidth / images[elmSprite.frame].naturalHeight;
				var Nwidth = canvas.width;
				var Nheight = (Nwidth / ratio);
							
				context.clearRect(0, 0, canvas.width, canvas.height);
				context.imageSmoothingEnabled = false;

				context.drawImage(images[elmSprite.frame], 0, 0, Nwidth, Nheight);
			}else{

				let posX = ( canvas.width - imageW ) / 2;
				let posY = (canvas.height - imageH) / 10;

				context.clearRect(0, 0, canvas.width, canvas.height);
				context.drawImage(images[elmSprite.frame], posX, posY);
			}
		}

	}

	// about - products demo
	const productsDemo = () => {

		gsap.utils.toArray(".wrap-list-demos").forEach(el => {

			gsap.from(el, {
				//height: 0,
				ease: "power4.out",
				duration: 1,
				scrollTrigger: {
					trigger: el,
					start: "top center",
					end: "center top",
					scrub: 2,
					toggleClass: 'motion-in',
					// markers:true
				}
			});

		})

	}


	const footerAnimate = (() => {

		const elmFooter = document.querySelector("footer");
		gsap.from(elmFooter, {
			scrollTrigger: {
				start: 'top 90%',
				trigger: elmFooter,
				toggleClass: 'motion-in',
				// markers : true
			}
		});

	});

	const intervalText = () => {

		$('.interval-text').find('.int-h1').toggleClass('el-hide');
		$('.interval-text').find('.img-greenday').toggleClass('el-hide');

		setTimeout(intervalText,3000);
		
	}

	return {

		parallaxWebdoor: parallaxWebdoor,
		animeTextIntro: animeTextIntro,


		init: function (el) {

			// if($('.interval-text').length > 0){
			// 	setTimeout(intervalText, 3000);
			// }

			if (document.getElementById("wrap-home-products")) {
				slideTopProducts();
			}

			if (document.getElementById("wrap-video")) {
				zoomOutVideo();
			}

			if (document.querySelector(".card-product-show")) {
				listProducts();
			}

			if (document.querySelector('.mask-layer-animation')) {
				layerMaskAnimation();
			}
		
			if (document.querySelector('#wrap-last-3-products')) {
				last3Home();
			}

			if(document.getElementById("animation-boske")){
				spriteProduct();
			}
			if(document.getElementById("animation-boske-pinha")){
				spriteProductPinha();
			}
			if(document.getElementById("animation-boske-guia")){
				spriteProductGuia();
			}
			
			if(document.querySelector(".wrap-list-demos")){
				productsDemo();
			}


			expImage();
			//footerAnimate();


			$(document).on('click', '[data-scrollto]', function () {
				elmToScroll($(this));
			});

			//quando ajax carregado forca ir topo da pagina
			if (el) {
				scrollToElm(el);
			}

		}
	}

}();

export default ScrollEvents;